import { useElementCssHeight } from "@hook";
import { inject, observer } from "mobx-react";
import { useRef } from "react";

import "./style.scss";

const Default = inject("mainStore")(
    observer(({ mainStore }) => {
        const theme = mainStore.getMainStore("theme");
        const customThemeTitle = mainStore.getMainStore("customThemeTitle");
        const headerRef = useRef(null);

        useElementCssHeight(headerRef, "--header-height", `${theme}-${customThemeTitle}`);

        return (
            <div className="header" ref={headerRef}>
                <div className="header__block">
                    <div className="header__logo"></div>
                    {customThemeTitle ? <span className="header__title">{customThemeTitle}</span> : <span className="header__title">{additioanalTitle[theme] ? additioanalTitle[theme] : "Выберите (1) подарок"}</span>}
                    <span className="header__description">у вас есть 5 минут</span>
                </div>
            </div>
        );
    }),
);

export default Default;

const additioanalTitle = {
    magnit: "Выберите (1) подарок от\u00A0Магнит",
    pochta: "Выберите (1) подарок от\u00A0Почты\u00A0России",
    aprel: "Выберите (1) подарок от\u00A0Аптеки\u00A0Апрель",
    wallet: "Выберите (1) подарок от\u00A0Кошелек",
    lenta: "Выберите (1) подарок от\u00A0Ленты",
    lemana: "Выберите (1) подарок от\u00A0Лемана\u00A0ПРО",
    kuper: "Выберите (1) подарок от\u00A0Купер",
    dm: "Выберите (1) подарок от партнеров\u00A0Детского\u00A0мира",
    eapteka: "Выберите (1) подарок от\u00A0ЕАПТЕКА",
};
